module.exports = __webpack_public_path__ + "static/media/rude.3933b568.svg";